class INTENT.widgets.UserSettings

  @ATTR_NAME: "data-widget-password-check"

  constructor: (@el) ->
    @s = @.constructor

    @minLength = 8;

    @input = @el.find('input[type="password"]')
    if !@input.length
      @input = @el

    @input.password
      shortPass: __('password-checker.status.short', {':count': @minLength}),
      badPass: __('password-checker.status.bad'),
      goodPass: __('password-checker.status.good'),
      strongPass: __('password-checker.status.strong'),
      enterPass: '',
      showText: true,
      minimumLength: @minLength
